const getEnv = (envName: string) => {
    const winEnv = window as any
    if (winEnv.env) {
        return winEnv.env[envName] || process.env[envName]
    }

    return process.env[envName]
}
const COMPANY_TENANT_IDENTIFIER_ID = getEnv(
    'REACT_APP_COMPANY_TENANT_IDENTIFIER_ID',
)
const LOCATION_TENANT_IDENTIFIER_ID = getEnv(
    'REACT_APP_LOCATION_TENANT_IDENTIFIER_ID',
)
const webVersion = getEnv('WEB_VERSION')
const CLOUD_API = getEnv('REACT_APP_CLOUD_API')
const ClientVersion = 'X-Client-Version'

export {
    CLOUD_API,
    webVersion,
    ClientVersion,
    LOCATION_TENANT_IDENTIFIER_ID,
    COMPANY_TENANT_IDENTIFIER_ID,
}
